var _defs, _path, _rect, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAiImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "empty-aiImg_svg___\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".empty-aiImg_svg__cls-2{fill:#2c2c2c}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "empty-aiImg_svg__cls-2",
    d: "M217.8 226.63c0 1.79-78.77 3.24-113.85 3.24s-81.76-1.45-81.76-3.24 46.68-3.24 81.76-3.24 113.85 1.45 113.85 3.24zM172.53 160.12L62 188.2c-3.88.99-7.82-1.36-8.81-5.24L25.12 72.49c-.99-3.88 1.36-7.82 5.24-8.81l16.14-4.1 94.39-23.98c3.88-.99 7.82 1.36 8.81 5.24l28.07 110.47c.99 3.88-1.36 7.82-5.24 8.81zM204.21 39.91h-6.78c-1.1 0-2-.9-2-2s.9-2 2-2h6.78c1.1 0 2 .9 2 2s-.9 2-2 2zM193.9 26.73c-.58 0-1.15-.25-1.54-.73-.7-.85-.58-2.11.27-2.81l4.48-3.69c.85-.7 2.11-.58 2.82.27.7.85.58 2.11-.27 2.81l-4.48 3.69c-.37.31-.82.46-1.27.46zm-13.24-5.6c-1.1 0-2-.9-2-2v-7c0-1.1.9-2 2-2s2 .9 2 2v7c0 1.1-.9 2-2 2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.32,
    y: 33.42,
    width: 133,
    height: 132.94,
    rx: 7.5,
    ry: 7.5,
    fill: "#19191a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "empty-aiImg_svg__cls-2",
    d: "M177.82 167.35h-118c-4.69 0-8.5-3.81-8.5-8.5V40.92c0-4.69 3.81-8.5 8.5-8.5h118c4.69 0 8.5 3.81 8.5 8.5v117.94c0 4.69-3.81 8.5-8.5 8.5zm-118-132.93c-3.58 0-6.5 2.92-6.5 6.5v117.94c0 3.58 2.92 6.5 6.5 6.5h118c3.58 0 6.5-2.92 6.5-6.5V40.92c0-3.58-2.92-6.5-6.5-6.5h-118z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "empty-aiImg_svg__cls-2",
    d: "M66.21 151.92V99.88s7.6-6.91 22.35-6.91c4.61 0 8.85.92 12.52 2.19 6.19 2.14 11.77 5.76 16.43 10.35l47.07 46.4H66.21z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "empty-aiImg_svg__cls-2",
    cx: 148.11,
    cy: 70.53,
    r: 15
  })));
}
export default SvgEmptyAiImg;